import { createOrderUrl } from "@saleor/createOrder/urls";
import urlJoin from "url-join";

export const orderCustomerProcessing = `${createOrderUrl}/order-processing`;
export const orderCustomerProcessingFailed = `${createOrderUrl}/order-processing-failed`;

export const orderCustomerCart = `${createOrderUrl}/create-order-customer`;

export const orderCustomerCartPath = (id: string) =>
  urlJoin(orderCustomerCart, id);
